import React from "react";
import { HashLink } from "react-router-hash-link";
import calf from "../../assets/images/Partition/4327350.png";
import sheep from "../../assets/images/Partition/4327268.png";
import fish from "../../assets/images/Partition/4327251.png";
import chicken from "../../assets/images/Partition/4327273.png";
import shrimp from "../../assets/images/Partition/4327341.png";
import { useState, useEffect } from "react";

import "./Partition.scss";
import { connection } from "utils/apiConnection.ts";
import { Link } from "react-router-dom";
const Partition = ({
  selectedItem,
  changeSelectedItem,
  dataLine,
  linesList,
  filterDataLine,
  subLines,
  productList,
}) => {
  const [data, setData] = useState([]);
  //   // {
  //   //   id: 1,
  //   //   title: "گوشت گوساله",
  //   //   image: calf,
  //   // },
  //   // {
  //   //   id: 2,
  //   //   title: "گوشت گوسفند",
  //   //   image: sheep,
  //   // },
  //   // {
  //   //   id: 3,
  //   //   title: "مرغ",
  //   //   image: chicken,
  //   // },
  //   // {
  //   //   id: 4,
  //   //   title: "ماهی",
  //   //   image: fish,
  //   // },
  //   // {
  //   //   id: 5,
  //   //   title: "میگو",
  //   //   image: shrimp,
  //   // },
  // ]);

  // useEffect(() => {
  //   connection("api/getlines", { supplier_id: 3 }).then((data) => {
  //     setData(data.lines);
  //   });
  // }, []);
  const filter = (names) => {
    if (linesList.length > 0) {
      let temp = linesList.filter(
        (d) => d.main.suppliers_line__id == selectedItem
      );
      switch (names) {
        case "title":
          return temp[0].main.title;
          break;
        case "path":
          return temp[0].main.path;
          break;
      }
    }
  };
  // console.log("datall", dataLine);

  return (
    <div className=" nav2 ">
      {selectedItem != -1 && (
        <div>
          <div className="card d-flex " style={{ borderRadius: "80%" }}>
            <div
              className="card-body "
              style={{
                cursor: "pointer",
                backgroundColor: "rgb(212 211 211)",
                boxShadow: "-5px 10px 15px #888888",
                width: "150px",
                borderRadius: "38px",
                height: "140px",
              }}
            >
              <img
                src={`http://sabadi.tatdemo.ir/${filter("path")}`}
                alt={`${filter("title")}`}
              />
              <br />
            </div>
          </div>
          <div className="title">{filter("title")}</div>
        </div>
      )}

      {dataLine != undefined &&
        dataLine.map((value, index) => {
          return (
            <CategoryPartion
              title={value.main.title}
              backgroundColor="red"
              coverPath={value.main.path}
              onClickHandler={() => {
                changeSelectedItem(value.main.suppliers_line__id);
                // filterDataLine(value.main.suppliers_line__id);
                subLines(value.main.suppliers_line__id);
                productList(value.main.suppliers_line__id, "apiLine");
              }}
            ></CategoryPartion>
          );
        })}
    </div>
  );
};

export const CategoryPartion = ({
  title,
  backgroundColor,
  coverPath,
  onClickHandler,
}) => {
  return (
    <div className="">
      <div className="card" style={{ borderRadius: "80%", height: "100px" }}>
        <div
          className="card-body"
          style={{ cursor: "pointer", backgroundColor: { backgroundColor } }}
          onClick={onClickHandler}
        >
          <img src={`http://sabadi.tatdemo.ir/${coverPath}`} alt={`${title}`} />
          <br />
        </div>
      </div>
      <div className="title ">{title} </div>
    </div>
  );
};
export default Partition;
